<div class="flex flex-col h-100-percent" [ngClass]="{'mt-12 ml-24 mr-12 mb-12 contact-us-mat-dialog': data?.matDialog ,'contact-us-dialog': !data?.matDialog }">
  <div class="flex flex-row justify-between">
    <div class="mat-headline-6 mb-4">{{'CONTACT_US.CONTACT_US' | transloco}}</div>
    <mat-icon svgIcon="close" (click)="data?.matDialog ? matdialogRef.close() : sidenavService.closeRightSidenav()"></mat-icon>
  </div>
  <div *ngIf="!messageSentTry" class="flex-row mb-16">
    <div class="mat-subtitle-2 subtitle-text">{{'CONTACT_US.WHATEVER_IS_IN_YOUR_MIND' | transloco}}</div>
  </div>

  <!-- validations? -->
  <ng-container *ngIf="!messageSentTry;else sentMessageResult;">
    <form [formGroup]="contactUsForm" class="mb-20">
      <div class="flex-col form-field">
        <label class="mb-6 mat-headline-6">{{'CONTACT_US.YOUR_MESSAGE' | transloco | uppercase}}</label>
        <textarea cdkTextareaAutosize class="p-10" formControlName="message"
                  maxlength="300"
                  placeholder="{{'CONTACT_US.TYPE_MESSAGE' | transloco}}" required>
        </textarea>
        <div class="flex flex-row justify-between text-width">
          <app-error [control]="contactUsForm.get('message')"></app-error>
          <span class="subtitle-text">{{contactUsForm.get('message').value.length}}/300</span>
        </div>
      </div>
    </form>
  </ng-container>

  <ng-template #sentMessageResult>
    <span *ngIf="sent;else failureMessage" @successMessage>
      <div class="flex flex-col justify-center items-center message-class-success mb-20 ml-20">
        <div class="green-oval mt-150 mb-20">
          <mat-icon svgIcon="done"></mat-icon>
        </div>
        <div class="mat-headline-5 mb-20">{{'CONTACT_US.MESSAGE_SENT' | transloco}}</div>
        <div class="subtitle-text mb-50">{{'CONTACT_US.WE_WILL_CONTACT_YOU' | transloco}}</div>
      </div>
    </span>
    <ng-template #failureMessage>
      <div class="flex flex-col justify-center items-center test overflow-y-auto">
        <div class="red-oval mt-30 mb-20">
          <mat-icon class="cursor-default" svgIcon="close"></mat-icon>
        </div>
        <div class="mat-headline-5 mb-20">{{'CONTACT_US.MESSAGE_NOT_SEND' | transloco}}</div>
        <div class="subtitle-text">{{'CONTACT_US.NOT_SEND_HINT' | transloco}}</div>
        <a class="mat-subtitle-2"
           href="mailto:bankingcloudsupport@temenos.com">{{'CONTACT_US.SUPPORT_MAIL' | transloco}}</a>
           <div class="flex flex-col mt-20 mb-50 message-class">
            <div class="flex flex-row">
            <label class="mb-4 mat-headline-6">{{'CONTACT_US.YOUR_MESSAGE' | transloco}}</label>
            <img (click)="copyText()" class="ml-20 icon mt-10" src="/assets/images/Vector.svg">
            <div *ngIf="displayTooltip" class="mat-subtitle-1 ml-4 mb-0 mt-4">{{'CONTACT_US.TEXT_COPIED' | transloco}}
            </div>
          </div>
          <textarea [(ngModel)]="typedMessage" class="inner-text-area subtitle-text pt-20 pr-30" id="text-content"
                    readonly="true"></textarea>
        </div>
      </div>
    </ng-template>
  </ng-template>

  <span class="flex-auto"></span>
  <mat-divider class="mb-32" ></mat-divider>

  <ng-container *ngIf="!messageSentTry; else showCloseButton">
    <div class="flex flex-row gap-x-4" dir="rtl">
      <button (click)="sendMessage()" [disabled]="contactUsForm.get('message').value.length === 0 || sendBtnClicked"
              class="accent"
              type="button">{{'BUTTONS.SEND' | transloco}}</button>
      <button (click)="data?.matDialog ? matdialogRef.close() : sidenavService.closeRightSidenav()" class="white" type="button">{{'BUTTONS.CANCEL' | transloco}}
      </button>
    </div>
  </ng-container>

  <ng-template #showCloseButton>
    <div class="flex flex-row gap-x-4" dir="rtl">
      <button (click)="data?.matDialog ? matdialogRef.close() : sidenavService.closeRightSidenav()" class="accent w-100-percent"
              type="button">{{'BUTTONS.CLOSE' | transloco}}</button>
    </div>
  </ng-template>
</div>
